import React from 'react';
import { FormattedMessage } from 'react-intl';

import { TextButton } from '@xingternal/button';
import { Flag } from '@xingternal/flag';
import { Column } from '@xingternal/xing-grid';

import { UpdateProfileCvCta } from '../';
import { useApplicationEmail } from '../../contexts';
import { useTrackSubmitConfirmationPageview } from '../../hooks';
import { Feedback } from '../feedback';
import { SubmitConfirmationHeader } from './submit-confirmation-header';

import * as S from './submit-confirmation-li-update-profile-cv.styles';
import { ContentWrapper } from './submit-confirmation.styles';

export const SubmitConfirmationLiUpdateProfileCv: React.VFC<{ onClose: () => void }> = ({ onClose }) => {
  const email = useApplicationEmail();

  useTrackSubmitConfirmationPageview();

  return (
    <Column size={10} sizeWide={8} offsetWide={2} offset={1}>
      <ContentWrapper>
        <SubmitConfirmationHeader copyKey="JOBS_INSTANT_APPLY_FORM_CONFIRMATION_UPDATE_PROFILE_HEADLINE" />
        <S.Body size="medium">
          <FormattedMessage
            id="JOBS_INSTANT_APPLY_FORM_CONFIRMATION_UPDATE_PROFILE_BODY"
            values={{ email, span: (chunks) => <span>{chunks}</span> }}
          />
        </S.Body>
        <S.Divider />
        <S.ProfileHeadline>
          <S.ProfileHeadlineText>
            <FormattedMessage id="JOBS_INSTANT_APPLY_FORM_CONFIRMATION_UPDATE_PROFILE_SUB_HEADLINE" />
          </S.ProfileHeadlineText>
          <Flag size="small" variant="beta" />
        </S.ProfileHeadline>
        <S.ProfileBody size="small">
          <FormattedMessage id="JOBS_INSTANT_APPLY_FORM_CONFIRMATION_UPDATE_PROFILE_SUB_BODY" />
        </S.ProfileBody>
        <S.UpdateProfileCtaWrapper>
          <UpdateProfileCvCta />
        </S.UpdateProfileCtaWrapper>
        <TextButton onClick={onClose} size="medium">
          <FormattedMessage id="JOBS_INSTANT_APPLY_FORM_CONFIRMATION_UPDATE_PROFILE_BACK_BUTTON" />
        </TextButton>
        <Feedback />
      </ContentWrapper>
    </Column>
  );
};
